exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".footer {\n  text-align: center;\n  padding: 40px;\n  background-color: #ebff66; }\n\n.footer__icon {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  max-width: 150px;\n  margin: 0 auto 15px; }\n\n.footer__icon > a {\n  transition: opacity 125ms ease; }\n  .footer__icon > a:hover {\n    opacity: 0.5; }\n\n.footer__icon > a > i {\n  display: block; }\n\n.footer__sub {\n  margin-bottom: 30px; }\n\n.footer__sub > h3 {\n  color: #333333;\n  font-weight: 600;\n  margin: 0;\n  font-size: 24px; }\n\n.footer__sub a {\n  color: #333333;\n  text-decoration: none;\n  border-bottom: 2px solid transparent;\n  transition: border-bottom-color 125ms ease; }\n  .footer__sub a:hover {\n    border-bottom-color: #333333; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader/lib!./~/sass-loader/lib/loader.js!./app/src/scss/Footer.scss
// module id = 235
// module chunks = 0